import React from 'react';

export default function ServiceCard({ service }) {
  const attrs = service.attributes || service;
  const features = attrs.features || [];

  return (
    <div className="card">
      <div className="card__icon">
        {attrs.icon === 'shield-check' ? '🛡️' : attrs.icon === 'search' ? '🔍' : '📊'}
      </div>
      <h3 className="card__title">{attrs.title}</h3>
      <p className="card__text">{attrs.shortDescription}</p>
      {features.length > 0 && (
        <ul className="card__features">
          {features.slice(0, 5).map((f, i) => (
            <li key={i}>{f}</li>
          ))}
        </ul>
      )}
      {attrs.externalUrl && (
        <a href={attrs.externalUrl} target="_blank" rel="noreferrer" className="btn btn--outline">
          Læs mere →
        </a>
      )}
    </div>
  );
}
